(function () {
    'use strict';

    angular.module('AngularAdmin')

        .factory('PlantSvc', ['$http', '$rootScope', '$q', 'ModalSvc', function ($http, $rootScope, $q, ModalSvc) {
            var plantSvc = {
                list: function (params) {
                    var url = `/plants/`;

                    return $http.get(url, {
                        params: params
                    });
                },
                get: function (plant_id) {
                    var url = `/api/plant/${plant_id}/`;
                    return $http.get(url, {});
                },
                delete: function (plant_id) {
                    var url = `/plant/delete/${plant_id}/`;
                    return $http({
                        method: 'DELETE',
                        url: url
                    });
                },
                restore: function (plant_id) {
                    var url = `/plant/restore/${plant_id}/`;
                    return $http.get(url, {});
                },
                getFeed: function (plant_id, config) {
                    var url = `/plant/${plant_id}/feed/`;
                    return $http({
                        method: 'GET',
                        url: url,
                        params: {
                            page_size: config.page_size,
                            page: config.page,
                            sort_by: config.sort_by,
                            sort_order: config.sort_order
                        }
                    });
                },
                getOrderFields: function (plant_id) {
                    var url = `/plant/${plant_id}/order_fields/`;
                    return $http.get(url, {});
                },
                createOrderField: function (plant_id, data) {
                    var url = `/plant/${plant_id}/order_field/new/`;
                    return $http.post(url, data);
                },
                updateOrderField: function (plant_id, data) {
                    var url = `/plant/${plant_id}/order_field/${data.id}/`;
                    return $http({
                        method: 'PATCH',
                        data: data,
                        url: url
                    });
                },
                renameOrderField: function(plant_id, field_id, new_name){
                    var url = `/plant/${plant_id}/order_field/${field_id}/rename/`;
                    return $http({
                        method: 'POST',
                        data: {
                            field_name: new_name
                        },
                        url: url
                    });
                },
                moveOrderField: function (plant_id, field_id, new_index) {
                  var url = `/plant/${plant_id}/order_field/${field_id}/move/`;
                  return $http({
                    method: 'POST',
                    data: {
                      new_index,
                    },
                    url: url
                  });
                },
                deleteOrderField: function (plant_id, order_field_id, confirm = true) {

                    var deferred = $q.defer();

                    if (confirm) {
                        var confirmation = ModalSvc.confirmationDialog.open({
                            title: `Delete order form field`,
                            message: `Are you sure you want to delete the order field?`
                        });

                        confirmation.result.then(function () {
                            doDelete();
                        });
                    }
                    else {
                        doDelete();
                    }

                    function doDelete() {
                        var url = `/plant/${plant_id}/order_field/${order_field_id}/delete/`;
                        return $http({
                            method: 'DELETE',
                            url: url
                        }).then(function (data) {
                            deferred.resolve(data);
                        }, function (data) {
                            deferred.reject(data);
                        });
                    }

                    return deferred.promise;
                },
                getSubscribers: function (plant_id) {
                    var url = String.format('/plant/{0}/subscribers/', plant_id);
                    return $http.get(url, {});
                },
                addSubscriber: function (plant_id, subscriber) {
                    var url = String.format('/plant/{0}/subscriber/new/', plant_id);
                    return $http({
                        method: 'POST',
                        url: url,
                        data: subscriber
                    });
                },
                deleteSubscriber: function (plant_id, subscriber_id, confirm = true) {

                    var deferred = $q.defer();

                    if (confirm) {
                        var confirmation = ModalSvc.confirmationDialog.open({
                            title: `Delete subscriber`,
                            message: `Are you sure you want to delete the subscriber?`
                        });

                        confirmation.result.then(function () {
                            doDelete();
                        });
                    }
                    else {
                        doDelete();
                    }

                    function doDelete() {
                        var url = `/plant/${plant_id}/subscriber/${subscriber_id}/delete/`;
                        return $http({
                            method: 'DELETE',
                            url: url
                        }).then(function (data) {
                            deferred.resolve(data);
                        }, function (data) {
                            deferred.reject(data);
                        });
                    }

                    return deferred.promise;

                },

                getCustomers: function (plant_id) {
                    var url = `/plant/${plant_id}/customers/`;
                    return $http.get(url, {});
                }
            };
            return plantSvc;
        }]);
})();
